// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill_t4nYF {
    padding: 4px 16px 4px 16px !important;
    text-align: center !important;
    font-family: Inter;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
}

.pane_iexgA {
    overflow-x: hidden !important;
}

.image_MmeOO {
    align-self: flex-start;
    padding-top: 24px;
}

.title_Ki8Za {
    font-family: 'Montserrat', sans-serif !important;
    font-size: 18px !important;
    line-height: 28px !important;
    letter-spacing: 0em !important;
    text-align: left;
    padding-top: 24px;
}

.bodyText_iqnt7 {
    font-family: 'Inter';
    font-weight: 200 !important;
    font-size: 15px !important;
    line-height: 24px !important;
    /* or 160% */
    align-items: center;

    /* Light/Base/700 */
    color: #394756 !important;
    padding-top: 12px;
    padding-bottom: 24px;
}

.footer_USYyR {
    padding: 0% 0% 0% 0% !important;
}

.dialog_lx6V3 {
    width: 397px !important;
    padding: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/Upsell.css"],"names":[],"mappings":"AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gDAAgD;IAChD,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;;IAEnB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');\n\n.pill {\n    padding: 4px 16px 4px 16px !important;\n    text-align: center !important;\n    font-family: Inter;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    line-height: 24px !important;\n}\n\n.pane {\n    overflow-x: hidden !important;\n}\n\n.image {\n    align-self: flex-start;\n    padding-top: 24px;\n}\n\n.title {\n    font-family: 'Montserrat', sans-serif !important;\n    font-size: 18px !important;\n    line-height: 28px !important;\n    letter-spacing: 0em !important;\n    text-align: left;\n    padding-top: 24px;\n}\n\n.bodyText {\n    font-family: 'Inter';\n    font-weight: 200 !important;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    /* or 160% */\n    align-items: center;\n\n    /* Light/Base/700 */\n    color: #394756 !important;\n    padding-top: 12px;\n    padding-bottom: 24px;\n}\n\n.footer {\n    padding: 0% 0% 0% 0% !important;\n}\n\n.dialog {\n    width: 397px !important;\n    padding: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pill": `pill_t4nYF`,
	"pane": `pane_iexgA`,
	"image": `image_MmeOO`,
	"title": `title_Ki8Za`,
	"bodyText": `bodyText_iqnt7`,
	"footer": `footer_USYyR`,
	"dialog": `dialog_lx6V3`
};
export default ___CSS_LOADER_EXPORT___;
